import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
import { api } from "@/api"
import type { ClientCurrencyCode } from "@/services/sharedTypes/tenants"

export type MerchantDetail = {
  id: string
  businessName: string

  customerName: string
  customerEmail: string
  customerPhone: string

  isActive: boolean

  transactionTotal: number
  transactionCount: number
  createdAt: Date
  firstTransactedAt: Date | null
  lastTransactedAt: Date | null
  portalLink: string

  isVatEnabled: boolean
  vatNumber: string
  isCashEnabled: boolean
  isGratuityEnabled: boolean

  isUnlinkedRefundsEnabled: boolean

  isProductsEnabled: boolean
  isCashiersEnabled: boolean
  isServiceChargeEnabled: boolean
  isSplitPaymentsEnabled: boolean

  transactionCountsByWeekday: {
    dayOfWeek: 1 | 2 | 3 | 4 | 5 | 6 | 7
    transactionCount: number
  }[]
  transactionCountsByWeekdayLastWeek: {
    dayOfWeek: 1 | 2 | 3 | 4 | 5 | 6 | 7
    transactionCount: number
  }[]

  currency: ClientCurrencyCode
}

const retrieveMerchantGroupMerchant = async (
  schemaName: string
): Promise<MerchantDetail> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<MerchantDetail>
  >(`/merchant-group/self/merchants/${schemaName}/`, {
    isMerchantGroup: true,
  })

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
    firstTransactedAt: body.firstTransactedAt
      ? DateFns.parseISO(body.firstTransactedAt)
      : null,
    lastTransactedAt: body.lastTransactedAt
      ? DateFns.parseISO(body.lastTransactedAt)
      : null,
  }
}

export const useMerchantGroupMerchant = (
  schemaName: MaybeRef<string>
) =>
  useQuery({
    queryKey: [
      BASE_MERCHANT_GROUP_MERCHANTS_QUERY_KEY,
      schemaName,
    ] as const,
    queryFn: ({ queryKey: [_, schemaName_] }) =>
      retrieveMerchantGroupMerchant(schemaName_),
  })
